
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { ShoppingBag } from 'lucide-react';

interface WooCommerceIntegrationSettingsProps {
  initialConnected?: boolean;
  onSaved: () => Promise<void>;
}

const WooCommerceIntegrationSettings: React.FC<WooCommerceIntegrationSettingsProps> = ({ 
  initialConnected = false,
  onSaved 
}) => {
  const [isConnected, setIsConnected] = useState(initialConnected);
  const [siteUrl, setSiteUrl] = useState('');
  const [consumerKey, setConsumerKey] = useState('');
  const [consumerSecret, setConsumerSecret] = useState('');

  const handleConnect = async () => {
    // Implement WooCommerce connection logic
    await onSaved();
    setIsConnected(true);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <ShoppingBag className="mr-2 h-6 w-6" />
          WooCommerce Integration
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Label>WooCommerce Connection</Label>
            <Switch 
              checked={isConnected}
              onCheckedChange={setIsConnected}
            />
          </div>

          {isConnected ? (
            <div className="space-y-4">
              <div>
                <Label>Site URL</Label>
                <Input 
                  value={siteUrl}
                  onChange={(e) => setSiteUrl(e.target.value)}
                  placeholder="https://your-wordpress-site.com"
                />
              </div>
              <div>
                <Label>Consumer Key</Label>
                <Input 
                  type="password"
                  value={consumerKey}
                  onChange={(e) => setConsumerKey(e.target.value)}
                  placeholder="Enter WooCommerce Consumer Key"
                />
              </div>
              <div>
                <Label>Consumer Secret</Label>
                <Input 
                  type="password"
                  value={consumerSecret}
                  onChange={(e) => setConsumerSecret(e.target.value)}
                  placeholder="Enter WooCommerce Consumer Secret"
                />
              </div>
              <Button onClick={handleConnect}>
                Update Connection
              </Button>
            </div>
          ) : (
            <Button onClick={handleConnect} className="w-full">
              Connect to WooCommerce
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default WooCommerceIntegrationSettings;
